export default __webpack_public_path__ + "static/media/tetu-ad-magazine.356e8fc3.png";